import { Modal } from 'antd';
import React from 'react';
import styles from './EditGoalModal.module.scss';
import {
  ButtonLabels,
  EditGoalModalProps,
  FieldLabels,
} from 'enums/EditGoalModalEnums';
import { Formik, Form } from 'formik';
import InputField from '../InputField';
import COButton from '../COButton';
import { validationSchema } from './EditGoalModalConstants';
import {
  DashboardGoalInterface,
  GoalProduct,
} from 'services/DashboardService/dashboard.service';

export interface EditGoalProps {
  showModalState: boolean;
  handleModalCancel: (payload: boolean) => void;
  handleModalConfirm: (payload: boolean) => void;
  preFetchedData?: GoalProduct | null;
  setGoal: (goal: DashboardGoalInterface) => Promise<void>;
  updateGoal: (goal: DashboardGoalInterface) => Promise<void>;
  product?: boolean;
  heading?: string;
  productId?: number | undefined;
  type?: string | undefined;
}

interface EditGoalFormValues {
  goal: string; // The form value for the goal input field
}

const EditGoalModal: React.FC<EditGoalProps> = ({
  showModalState,
  handleModalCancel,
  handleModalConfirm,
  preFetchedData,
  setGoal,
  updateGoal,
  product,
  heading,
  productId,
  type,
}: EditGoalProps) => {
  const handleCloseModal = () => {
    handleModalConfirm(false);
  };
  const handleCancelModal = () => {
    handleModalCancel(false);
  };
  const preFetchedValue: EditGoalFormValues = {
    goal: preFetchedData?.co2e?.toString() ?? '',
  };

  const handleFormSubmission = async (values: EditGoalFormValues) => {
    const goal = Number(values.goal);
    try {
      if (product) {
        if (preFetchedData?.co2e !== undefined) {
          await updateGoal({
            type: type,
            co2e: goal,
          });
        } else {
          setGoal({
            type: type,
            co2e: goal,
          });
        }
      } else {
        if (preFetchedData?.co2e !== undefined) {
          await updateGoal({
            type: type,
            dashboard_id: productId,
            co2e: goal,
          });
        } else {
          setGoal({
            type: type,
            dashboard_id: productId,
            co2e: goal,
          });
        }
      }
      handleCloseModal();
    } catch (error) {
      console.error('Something went wrong:', error);
    }
  };

  return (
    <Modal
      open={showModalState}
      onOk={handleCloseModal}
      onCancel={handleCancelModal}
      wrapClassName={styles.modalContainer}
      footer={null}
      width={EditGoalModalProps.MODAL_WIDTH}
      destroyOnClose={true}>
      <div className={styles.formContainer}>
        <div className={styles.headerContainer}>
          {product ? (
            <h2>{EditGoalModalProps.ALLPRODUCTSHEADING}</h2>
          ) : (
            <h2>{heading}</h2>
          )}
        </div>
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={preFetchedValue}
          onSubmit={handleFormSubmission}>
          {formik => (
            <Form>
              <div className={styles.fieldContainer}>
                <InputField
                  name={FieldLabels.EMISSION_GOAL}
                  placeholderstring={FieldLabels.EMISSION_PLACEHOLDER}
                  label={FieldLabels.EMISSON_LABEL}
                />
              </div>
              <div className={styles.buttonContainer}>
                <COButton submit loading={formik.isSubmitting}>
                  {preFetchedData?.co2e
                    ? ButtonLabels.CONFIRM
                    : ButtonLabels.SET}
                </COButton>

                <COButton secondary onClick={handleCancelModal}>
                  {ButtonLabels.CANCEL}
                </COButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default EditGoalModal;
